import clsx from 'clsx'
import React, { FC, PropsWithChildren } from 'react'

import styles from './TextWithMoreAndLess.module.scss'

export interface TextWithMoreAndLessProps {
  className?: string
  id: string
  lessText?: string
  moreText?: string
}

export const TextWithMoreAndLess: FC<PropsWithChildren<TextWithMoreAndLessProps>> = ({ children, className, id, lessText, moreText }) => (
  <div className={clsx(className, styles.textWithMoreAndLess)}>
    <input id={id} type="checkbox" />
    <label className={styles.content} htmlFor={`${id}2`}>
      {children}
    </label>
    <label className={styles.readMore} htmlFor={id}>{moreText}</label>
    <label className={styles.readLess} htmlFor={id}>{lessText}</label>
  </div>
)

